export const shoppingPathTypeNames = ['리뷰', '카탈로그','구매미션','플러스스토어']